module.exports = __webpack_public_path__ + "img/upload-icon.2d362230.svg";